import React from 'react'
import Header from './components/Header/Header'
import Content from './components/Content/Content'

function App() {
  return (
    <div>
      <Header />
      <Content />
    </div>
  )
}

export default App